import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = (state) => state[NAME].byId
export const getClosureIds = (state) => state[NAME].allKeys

export const getClosureById = createSelector([byIdSelector], (byId) => (id) =>
  byId[id] || null
)

export const getClosures = createSelector(
  [getClosureById, getClosureIds],
  (byId, allKeys) => allKeys.map(byId)
)

export const getClosuresIsLoading = (state) => state[NAME].roadClosuresIsLoading

export const getSelectedClosureIds = (state) => state[NAME].selected.closureIds
export const getCurrentSelectedIndex = (state) => state[NAME].selected.current

const getSelectedClosureId = createSelector(
  [getSelectedClosureIds, getCurrentSelectedIndex],
  (eventIds, current) => eventIds[current]
)

export const getAllSelectedClosures = createSelector(
  [getSelectedClosureIds, getClosureById],
  (closureIds, byId) => closureIds.map(byId)
)

export const getSelectedCount = createSelector(
  [getSelectedClosureIds],
  (selectedIds) => selectedIds.length
)

export const getCurrentSelectedClosure = createSelector(
  [getSelectedClosureId, getClosureById],
  (closureId, byId) => byId(closureId)
)

export const getEditor = (state) => state[NAME].editor

/**** Agencies */

export const getAgencyIds = (state) => state[NAME].agencyKeys
const agencyByIdSelector = (state) => state[NAME].agenciesById

export const getAgencyById = createSelector(
  [agencyByIdSelector],
  (byId) => (id) => byId[id] || null
)

export const getAgencies = createSelector(
  [getAgencyById, getAgencyIds],
  (byId, allKeys) => allKeys.map(byId)
)
